import { fromJS } from 'immutable';

export const UPDATE_USER = 'UPDATE_USER';
export const CLEAR_USER = 'CLEAR_USER';

export const CHECK_USER_REQUEST = 'CHECK_USER_REQUEST';
export const CHECK_USER_SUCCESS = 'CHECK_USER_SUCCESS';
export const CHECK_USER_FAILURE = 'CHECK_USER_FAILURE';

const defaultUser = fromJS({
  userName: '',
  displayName: '',
  authorities: [],
});

const initialState = fromJS({
  apiToken: '',
  user: defaultUser,
  checkingAuthorities: false,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER: {
      const currentUser = state.get('user');
      const currentToken = state.get('apiToken');
      let doMerge = false;
      const merge = {};
      const nextUserName = action.user.userName;
      const currentUserName = currentUser.get('userName');
      if (currentUserName !== nextUserName) {
        doMerge = true;
        merge.user = action.user;
        merge.user.displayName = merge.user.userName;
      }
      if (currentToken !== action.apiToken) {
        doMerge = true;
        merge.apiToken = action.apiToken;
      }
      if (doMerge) {
        return state.merge(fromJS(merge));
      }
      return state;
    }
    case CLEAR_USER:
      return state.merge(fromJS({ user: defaultUser, apiToken: '' }));
    case CHECK_USER_REQUEST:
      return state.merge(fromJS({ checkingAuthorities: true }));
    case CHECK_USER_SUCCESS: {
      const { username, authorities } = action.response;
      const user = state.get('user').toJS();
      if (user.userName !== username) {
        user.authorities = [];
        return state.merge(fromJS({ user, checkingAuthorities: false }));
      }

      const existingAuthorities = user.authorities;
      if (!fromJS(existingAuthorities).equals(fromJS(authorities))) {
        user.authorities = authorities;
        return state.merge(fromJS({ user, checkingAuthorities: false }));
      }
      return state.merge(fromJS({ checkingAuthorities: false }));
    }
    case CHECK_USER_FAILURE:
      return state.merge(fromJS({ user: defaultUser, checkingAuthorities: false }));

    default:
      return state;
  }
};
